import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
// material 
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// components
import { LoginForm } from '../../components/authentication/login'
//import { MHidden } from '../../components/@material-extend';


function Login() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="sm">
        <div className={classes.content}>
          <Card sx={{padding: 5}}>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Iniciar Sesión a Journey Sports
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>Ingresa tus datos debajo</Typography>
              </Box>
            </Stack>
            <LoginForm />
            {/* <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              No tienes una cuenta?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                Haz click para crear una
              </Link>
            </Typography> */}
          </Card>
        </div>
      </Container>
    </div>
  )
}

export default Login

const useStyles = makeStyles({
  root: {
    display: 'flex',
    paddingTop: '20px',
  },
  content: {
      maxWidth: 480,
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '40px'
  }
});
